import { bootstrapApplication } from 'application';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

bootstrapApplication().then(renderApplication).catch(logInitializationError);

function renderApplication() {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(<App />);
}

function logInitializationError(err: Error) {
  console.error(err);
}
